import { hashString } from '@w/utils'

/**
 * Creates a sampler for consistent per-trace sampling decisions.
 * Once a trace is sampled (or not), all subsequent checks for that trace
 * return the same decision.
 */
export function createSampler(rate: number) {
  if (rate < 0 || rate > 1) {
    throw new Error(`Sample rate must be between 0 and 1, got ${rate}`)
  }

  return {
    /**
     * Returns true if the trace should be exported.
     */
    shouldExport(traceId: string): boolean {
      if (rate === 1) return true
      if (rate === 0) return false

      return deterministicSample(traceId) < rate
    },
  }
}

function deterministicSample(traceId: string): number {
  const hash = hashString(traceId, 'tel-sampler-v1')
  const prefix = hash.slice(0, 13)
  return Number.parseInt(prefix, 16) / 0x10000000000000
}

export type Sampler = ReturnType<typeof createSampler>
